import { List, Datagrid, TextField, DateField, UrlField } from "react-admin";
import { RowShow } from "../../resources/trackedCVE";
import SeverityChipField from "../SeverityChipField";
import { Card, CardContent, CardHeader } from "@mui/material";

const CriticalList: React.FC<{
  releaseName: string;
  releaseVersion: string;
}> = ({ releaseName, releaseVersion }) => {
  return (
    <Card sx={{ marginTop: "2em" }}>
      <CardHeader title="High/Critical Open CVEs" />
      <CardContent
        sx={{
          padding: "0",
          "&:last-child": {
            paddingBottom: "0",
          },
        }}
      >
        <List
          disableSyncWithLocation
          resource="cve/tracked-cves"
          actions={false}
          title={false}
          empty={false}
          filter={{
            $or: [{ severity: "critical" }, { severity: "high" }],
            vulnerableReleaseName: releaseName,
            vulnerableReleaseVersion: releaseVersion,
            status: { $ne: "closed" },
            availableFixedImageBuildTag: { $eq: "null" },
          }}
          sort={{ field: "createdAt", order: "ASC" }}
        >
          <Datagrid rowClick="show" expand={<RowShow />}>
            <TextField source="name" />
            <TextField
              source="targetFixReleaseVersion"
              label="Target Version"
            />
            <DateField source="targetFixReleaseDate" label="Target Date" />
            <TextField source="availableFixedImageBuildTag" />
            <UrlField source="githubIssue" />
            <SeverityChipField source="severity" />
            <DateField source="createdAt" />
          </Datagrid>
        </List>
      </CardContent>
    </Card>
  );
};

export default CriticalList;
